module.exports = __webpack_public_path__ + "img/icon.5818bf32.png";